import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { MaterialIcon } from '../MaterialIcon';
import { Dialog } from '../Dialog';
import { DialogHeader } from '../DialogHeader';
import { DialogBody } from '../DialogBody';
import { DialogFooter } from '../DialogFooter';
import { Button } from '../Button';
import FeedbackCard from '../FeedbackCard';

export const ConfirmationModal = ({
    header,
    body,
    confirmButtonText,
    confirmButtonProps = { appearance: 'primary', text: true },
    closeDialog,
    onConfirm,
    autoHeight
}) => {
    const [loading, setLoading] = useState('');
    const [fatalError, setFatalError] = useState(null);

    const CloseDialog = () => {
        return typeof closeDialog === 'function' ? closeDialog() : null;
    };

    const Confirm = () => {
        setLoading('loading');
        onConfirm()
            .then((resp) => {
                setLoading('success');
                setTimeout(() => {
                    setLoading('');
                    CloseDialog();
                }, 500);
            })
            .catch((e) => {
                setFatalError(e);
                setLoading('');
            });
    };

    return (
        <div style={autoHeight ? {} : { height: `30rem` }}>
            <Dialog close={CloseDialog} size="md" visible id="criteria-manager-confirmation-modal">
                <DialogHeader close={CloseDialog}>{header}</DialogHeader>
                <DialogBody>
                    {body}
                    {fatalError != null && (
                        <FeedbackCard
                            intent={'danger'}
                            feedback={{
                                heading: `An error has occurred.`,
                                message: `Please wait a few moments before trying your request
        again.`
                            }}
                            details={fatalError}
                        />
                    )}
                </DialogBody>
                <DialogFooter>
                    {loading === 'loading' && <div style={{ marginRight: '0.5rem' }}>Loading...</div>}
                    {loading === 'success' && (
                        <div style={{ marginRight: '0.5rem' }}>
                            <MaterialIcon icon={'done_outline'} color={'#04846D'} />
                        </div>
                    )}
                    <Button {...confirmButtonProps} onClick={Confirm} disabled={loading !== ''}>
                        {confirmButtonText}
                    </Button>
                    <Button appearance="secondary" text onClick={CloseDialog}>
                        Cancel
                    </Button>
                </DialogFooter>
            </Dialog>
        </div>
    );
};

ConfirmationModal.propTypes = {
    onConfirm: PropTypes.func.isRequired,
    header: PropTypes.string.isRequired,
    body: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    confirmButtonText: PropTypes.string.isRequired,
    confirmButtonProps: PropTypes.object,
    data: PropTypes.object,
    autoHeight: PropTypes.bool,
    closeDialog: PropTypes.func.isRequired
};

export default ConfirmationModal;
